var _a;
import { TpaPageIds } from './page-mapping';
import { productPageMapping } from './supported-verticals/product-page';
import { postMapping } from './supported-verticals/post';
import { blogMapping } from './supported-verticals/blog';
import { forumMapping } from './supported-verticals/forum';
import { groupMapping } from './supported-verticals/group';
import { bookingsMapping } from './supported-verticals/bookings';
import { challengesMapping } from './supported-verticals/challenges';
/**
 * For more detailed instructions please read the docs:
 * https://github.com/wix-private/promote-seo/blob/master/packages/README.md#vertical-mapping
 */
export var verticalsMapping = (_a = {},
    _a[TpaPageIds.product_page] = productPageMapping,
    _a[TpaPageIds.post] = postMapping,
    _a[TpaPageIds.blog] = blogMapping,
    _a[TpaPageIds.forum] = forumMapping,
    _a[TpaPageIds.group] = groupMapping,
    _a[TpaPageIds.bookings] = bookingsMapping,
    _a[TpaPageIds.challenges] = challengesMapping,
    _a);
//# sourceMappingURL=verticals-mapping.js.map